import { render, staticRenderFns } from "./ProductRowItemsTable.vue?vue&type=template&id=14a1b966&"
import script from "./ProductRowItemsTable.vue?vue&type=script&lang=ts&"
export * from "./ProductRowItemsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports